<main class="sr-organic-landing">
  <section id="home" class="hero-section">
    <header class="site-header" aria-label="S.R.Organic main navigation">
      <a class="brand" routerLink="/" fragment="home" aria-label="S.R. Organic home">
        <span class="brand-mark" aria-hidden="true">🍄</span>
        <span class="brand-copy">
          <strong>S.R.ORGANIC</strong>
        </span>
      </a>

      <nav class="main-nav" aria-label="Primary navigation">
        <a
          *ngFor="let item of navItems; let first = first; trackBy: trackByTitle"
          [class.active]="first"
          [routerLink]="item.route"
          [fragment]="item.fragment"
        >
          {{ item.label }}
        </a>
      </nav>

      <div class="header-actions">
        <button class="icon-button sun-button" type="button" aria-label="Toggle theme">
          <span></span>
        </button>
        <button class="icon-button menu-button" type="button" aria-label="Open menu">
          <i></i>
          <i></i>
        </button>
      </div>
    </header>

    <div class="hero-stage">
      <article class="hero-copy">
        <p class="eyebrow">{{ heroContent.eyebrow }} <span>🌿</span></p>
        <h1>
          {{ heroContent.headline }}
          <span>{{ heroContent.subHeadline }}</span>
        </h1>
        <p class="hero-description">
          {{ heroContent.description }}
        </p>

        <div class="hero-actions">
          <a class="primary-button" routerLink="/products">
            {{ heroContent.primaryButtonText }}
            <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </article>

      <div class="hero-visual" aria-label="Mushrooms growing from rich soil">
        <div class="glow-ring"></div>
        <div class="soil-particles particles-a"></div>
        <div class="soil-particles particles-b"></div>
        <!-- Replace this image with the final cutout/product mushroom asset if needed. -->
        <img [src]="heroContent.heroImageUrl || heroImage" alt="Premium organic mushrooms growing in soil" />
      </div>

    </div>

    <section class="trust-badge-bar" aria-label="S.R.Organic trust badges">
      <article
        *ngFor="let badge of trustBadges; trackBy: trackByTitle"
        class="trust-badge"
      >
        <span class="trust-badge__icon" [attr.data-icon]="badge.icon"></span>
        <span class="trust-badge__content">
          <strong class="trust-badge__title">{{ badge.title }}</strong>
          <small class="trust-badge__subtitle">{{ badge.subtitle }}</small>
        </span>
      </article>
    </section>
  </section>

  <section id="about" class="journey-section" aria-label="The S.R.Organic journey">
    <div class="journey-copy">
      <p class="section-eyebrow">{{ journeyContent.eyebrow }} <span>🌿</span></p>
      <h2>
        {{ journeyContent.title }}
      </h2>
      <p>
        {{ journeyContent.description }}
      </p>
    </div>

    <div class="journey-track">
      <article
        *ngFor="let step of journeySteps; let i = index; trackBy: trackByTitle"
        class="journey-step"
        [style.animation-delay.ms]="120 + i * 90"
      >
        <div class="step-card">
          <img [src]="step.image" [alt]="step.title + ' step preview'" />
        </div>
        <strong>{{ step.index }}</strong>
        <span>{{ step.title }}</span>
      </article>
    </div>
  </section>

  <section
    id="products"
    class="products-section"
    aria-label="S.R.Organic products"
    [style.--product-accent]="activeProduct.accent || '#c8ef5a'"
    [style.--product-glow]="activeProduct.glow || 'rgba(200, 239, 90, 0.44)'"
    [style.--product-bg]="activeProduct.background || 'rgba(102, 130, 35, 0.2)'"
    [style.--particle-color]="activeProduct.particle || 'rgba(216, 244, 99, 0.74)'"
  >
    <div class="product-aurora" aria-hidden="true"></div>
    <div class="product-particles product-particles-a" aria-hidden="true"></div>
    <div class="product-particles product-particles-b" aria-hidden="true"></div>

    <div class="products-heading">
      <p class="section-eyebrow">OUR PRODUCTS <span>🌿</span></p>
      <h2>
        Sustainable By-Products
        <span>For Multiple Industries</span>
      </h2>
      <p>
        Select a product stream to explore the focused child products S.R.Organic
        can supply for food, wellness, farming, industrial, and research needs.
      </p>
    </div>

    <div class="product-carousel">
      <button
        type="button"
        class="product-carousel-button product-carousel-button--prev"
        aria-label="Show previous product"
        (click)="showPreviousProduct()"
      >
        <span aria-hidden="true">&larr;</span>
      </button>

      <div class="product-showcase">
      <article
        *ngFor="let product of products; let i = index; trackBy: trackByTitle"
        class="product-card"
        role="button"
        tabindex="0"
        [ngClass]="getProductPositionClass(i)"
        [class.active]="i === selectedProductIndex"
        [style.--card-accent]="product.accent || '#c8ef5a'"
        [style.--card-glow]="product.glow || 'rgba(200, 239, 90, 0.44)'"
        [style.animation-delay.ms]="120 + i * 90"
        (click)="selectProduct(i)"
        (keydown.enter)="selectProduct(i)"
        (keydown.space)="selectProduct(i)"
        [attr.aria-pressed]="i === selectedProductIndex"
      >
        <span class="product-card__halo" aria-hidden="true"></span>
        <span class="product-card__media">
          <img [src]="product.imageUrl" [alt]="product.name + ' product preview'" />
        </span>
        <span class="product-card__content">
          <span class="product-card__icon" aria-hidden="true">{{ product.icon || '◎' }}</span>
          <strong>{{ product.name }}</strong>
          <span>{{ product.shortDescription }}</span>
        </span>
        <a
          class="product-card__action"
          [routerLink]="['/products', product.id]"
          (click)="$event.stopPropagation()"
        >
          Explore <span aria-hidden="true">&rarr;</span>
        </a>
      </article>
      </div>

      <button
        type="button"
        class="product-carousel-button product-carousel-button--next"
        aria-label="Show next product"
        (click)="showNextProduct()"
      >
        <span aria-hidden="true">&rarr;</span>
      </button>
    </div>

    <div class="active-product-panel" [attr.data-active-product]="selectedProductIndex">
      <article class="product-detail-card">
        <span class="product-detail-card__icon" aria-hidden="true">{{ activeProduct.icon || '◎' }}</span>
        <p>Selected Product</p>
        <h3>{{ activeProduct.name }}</h3>
        <span>{{ activeProduct.fullDescription || activeProduct.shortDescription }}</span>
      </article>

      <article class="product-stat-card">
        <strong>{{ getChildrenForSelectedProduct().length }}</strong>
        <span>Child products</span>
      </article>

      <div class="child-products" [attr.data-products-key]="selectedProductIndex">
        <div class="child-products__header">
          <strong>Child Products</strong>
          <span>{{ activeProduct.name }}</span>
        </div>
        <article
          *ngFor="let child of getChildrenForSelectedProduct(); let i = index; trackBy: trackByTitle"
          class="child-product"
          [style.animation-delay.ms]="80 + i * 80"
        >
          <span class="child-product__index">0{{ i + 1 }}</span>
          <strong>{{ child.name }}</strong>
          <p>{{ child.shortDescription || child.longDescription }}</p>
          <a [routerLink]="['/products', child.id]">
            Explore <span aria-hidden="true">&rarr;</span>
          </a>
        </article>

        <article class="child-product child-product--empty" *ngIf="!getChildrenForSelectedProduct().length">
          <strong>No child products available yet.</strong>
          <p>{{ activeProduct.status === 'inactive' ? 'This product stream is currently out of stock.' : 'New items will appear here soon.' }}</p>
        </article>
      </div>
    </div>
  </section>

  <div class="why-footer-screen">
    <section
      id="why-us"
      #impactSection
      class="why-impact-section"
      [class.is-visible]="impactVisible"
      aria-label="Why choose S.R.Organic and impact statistics"
    >
    <div class="why-impact-main">
      <article class="why-copy">
        <p class="section-eyebrow">{{ whyChooseUsContent.eyebrow }}</p>
        <h2>
          {{ whyChooseUsContent.title }}
        </h2>
        <p>
          {{ whyChooseUsContent.description }}
        </p>
        <button class="impact-cta" type="button">
          Know More About Us
          <span aria-hidden="true">&rarr;</span>
        </button>
      </article>

      <div class="comparison-stage" aria-label="S.R.Organic comparison">
        <article
          *ngFor="let group of comparisonGroups; let groupIndex = index; trackBy: trackByComparisonTitle"
          class="comparison-card"
          [class.comparison-card--positive]="group.tone === 'positive'"
          [class.comparison-card--negative]="group.tone === 'negative'"
        >
          <h3>{{ group.title }}</h3>
          <ul>
            <li
              *ngFor="let item of group.items; let i = index"
              [style.animation-delay.ms]="220 + groupIndex * 160 + i * 80"
            >
              <span class="comparison-icon" aria-hidden="true">
                {{ group.tone === 'positive' ? '✓' : '×' }}
              </span>
              <span>{{ item }}</span>
            </li>
          </ul>
        </article>

        <div class="vs-orb" aria-hidden="true">VS</div>
      </div>

      <div class="impact-mushroom-art" aria-hidden="true">
        <img [src]="networkMushroomImage" alt="" />
      </div>
    </div>

    <section id="sustainability" class="impact-stats-wrap">
      <h2>{{ impactStatsContent.title }}</h2>

      <div class="impact-stats-grid">
        <article
          *ngFor="let stat of impactStats; let i = index; trackBy: trackByLabel"
          class="impact-stat"
          [style.animation-delay.ms]="160 + i * 90"
        >
          <span class="impact-stat__icon" aria-hidden="true">{{ stat.icon }}</span>
          <span class="impact-stat__copy">
            <strong>{{ formatImpactValue(impactDisplayValues[i]) }}{{ stat.suffix }}</strong>
            <small>{{ stat.label }}</small>
          </span>
        </article>
      </div>
    </section>
    </section>

    <footer
      #siteFooter
      class="site-footer"
      [class.is-visible]="footerVisible"
      aria-label="S.R.Organic footer"
    >
    <div class="footer-glow" aria-hidden="true"></div>

    <div class="footer-grid">
      <section class="footer-brand" aria-label="S.R.Organic brand">
        <a class="footer-logo" routerLink="/" fragment="home" aria-label="S.R.Organic home">
          <span class="footer-logo__mark" aria-hidden="true">🍄</span>
          <strong>S.R.ORGANIC</strong>
        </a>
        <p>{{ footerContent.companyDescription }}</p>
        <div class="footer-socials" aria-label="Social links">
          <a
            *ngFor="let social of socialLinks; trackBy: trackByFooterLabel"
            [href]="social.href"
            [attr.aria-label]="social.label"
          >
            {{ social.label.charAt(0) }}
          </a>
        </div>
      </section>

      <nav class="footer-column" aria-label="Quick links">
        <h2>Quick Links</h2>
        <a *ngFor="let link of quickLinks; trackBy: trackByFooterLabel" [routerLink]="link.route" [fragment]="link.fragment">
          {{ link.label }}
        </a>
      </nav>

      <nav class="footer-column" aria-label="Product links">
        <h2>Our Products</h2>
        <a *ngFor="let link of productLinks; trackBy: trackByFooterLabel" [routerLink]="link.route" [fragment]="link.fragment">
          {{ link.label }}
        </a>
      </nav>

      <section id="contact" class="footer-column footer-contact" aria-label="Contact us">
        <h2>Contact Us</h2>
        <article *ngFor="let item of contactItems; trackBy: trackByFooterLabel">
          <span aria-hidden="true">{{ item.icon }}</span>
          <p>
            <strong>{{ item.label }}</strong>
            <small>{{ item.value }}</small>
          </p>
        </article>
      </section>

      <section class="footer-column footer-sponsors" aria-label="Our sponsors">
        <h2>Our Sponsors</h2>
        <span
          *ngFor="let sponsor of sponsorItems; let i = index; trackBy: trackBySponsor"
          [style.animation-delay.ms]="260 + i * 80"
        >
          {{ sponsor }}
        </span>
      </section>
    </div>

    <div class="footer-bottom">
      <span>© 2026 S.R.Organic. All rights reserved.</span>
      <span>Pure inputs. Circular systems. Better futures.</span>
    </div>
    </footer>
  </div>
</main>
